
/**
 * Represents a Link as sent to the backend
 * All offest are in unicode codepoints (as opposed to UCS2 16bit code units)
 */
export class Link {

  constructor(startLineCh, endLineCh, url) {
    this.startLineCh = startLineCh;
    this.endLineCh = endLineCh;
    this.url = url;
    this.wrapped = true;
  }

  setIsShortnerDisabled(disabled) {
    this.isShortnerDisabled = disabled;
    this.wrapped = !disabled;
  }

  setId(id) {
    this.id = id;
  }

  // this is in a separate method from the constructor for the convenience of LinksDetector
  // (the twttr lib converts from UCS2 to CP all links of a given line at once)
  setRawOffsets(startCP, endCP, lineOffsetCP) {
    this.startRaw = lineOffsetCP + startCP;
    this.endRaw = lineOffsetCP + endCP;
  }

  setIdAndOffsetsAndUrl(link) {
    this.id = link.id;
    this.startRaw = link.startRaw;
    this.endRaw = link.endRaw;
    this.startLineCh = link.startLineCh;
    this.endLineCh = link.endLineCh;
    this.url = link.url;
  }
}
